/**
 * Controles do WES Identity no topo do app.
 *
 * - O nome do médico sempre visível (PBI-05 e PBI-07): é o que permite notar
 *   uma troca acidental de médico antes de qualquer ação. No desktop o menu
 *   do usuário já o mostra; abaixo de 1200px aquele bloco some, e a etiqueta
 *   daqui assume.
 * - O modo restrito tem indicador persistente, não aviso que some (PBI-06).
 * - "Ocultar sessão" só existe no build de demonstração.
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIdentitySession } from '../../context/IdentitySessionContext';
import AppToast, { toastDurationFor } from '../common/AppToast';

export default function IdentityTopbarControls() {
  const { t } = useTranslation();
  const {
    hasStationSession,
    fullName,
    restricted,
    sensitiveActionsBlocked,
    demoEnabled,
    maskForDemo,
  } = useIdentitySession();
  const [toast, setToast] = useState(null);

  if (!hasStationSession) return null;

  return (
    <div className="identity-doctor-controls">
      {fullName ? (
        <span className="identity-doctor-name" title={fullName}>
          <span className="material-symbols-rounded" aria-hidden="true">badge</span>
          <span className="identity-doctor-name-text">{fullName}</span>
        </span>
      ) : null}

      {restricted ? (
        <button
          type="button"
          className="identity-restricted-chip"
          onClick={() => setToast({ message: t('identity.restricted.explanation'), severity: 'warning' })}
        >
          {t('identity.restricted.chip')}
        </button>
      ) : null}

      {/* Motivo diferente do modo restrito: aqui a operadora respondeu, mas a
        * prova foi o PIN, mais fraca que o rosto (PBI-09). */}
      {sensitiveActionsBlocked ? (
        <button
          type="button"
          className="identity-restricted-chip"
          onClick={() => setToast({ message: t('identity.pinLimited.explanation'), severity: 'warning' })}
        >
          {t('identity.pinLimited.chip')}
        </button>
      ) : null}

      {demoEnabled ? (
        <button
          type="button"
          className="icon-btn identity-mask-session-btn"
          onClick={maskForDemo}
          aria-label={t('identity.demo.maskSession')}
          title={t('identity.demo.maskSession')}
        >
          <span className="material-symbols-rounded" aria-hidden="true">shield_lock</span>
        </button>
      ) : null}

      <AppToast
        toast={toast}
        onClose={() => setToast(null)}
        autoHideDuration={toastDurationFor(toast && toast.message)}
      />
    </div>
  );
}
